import React, {useState} from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {Star} from '../../../assets';
import {TierCards} from '../../../components/Cards/TierCard';
import {BottomCard} from '../../../components/Cards/BottomCard';
import {Comparisone} from '../../../components/Comparisone';

export const Hero = () => {
  const [toggle, setToggle] = useState('monthly');
  const [active, setActive] = useState(false);

  const handleToggle = () => {
    setToggle((prev) => (prev === 'monthly' ? 'annually' : 'monthly'));
  };

  return (
    <div className={styles.hero}>
      <div className={styles.top}>
        <div className={styles.label}>
          <Star />
          Premium
        </div>
        <h1 className={styles.title}>Simple, transparent pricing with no surprises</h1>
        <p className={styles.subTitle}>
          Unlock the full potential of your server by getting full access to all Themis advanced
          features
        </p>
      </div>
      <div className={styles.toggleWrapper}>
        <div className={styles.toggle}>
          <div
            className={clsx(styles.toggleButton, {
              [styles.active]: toggle === 'monthly',
            })}
            onClick={handleToggle}>
            Monthly
          </div>
          <div
            className={clsx(styles.toggleButton, {
              [styles.active]: toggle === 'annually',
            })}
            onClick={handleToggle}>
            Annually
          </div>
        </div>
      </div>
      <TierCards />
      <div className={styles.bottomCardWrapper}>
        <BottomCard secondary />
      </div>
      <Comparisone toggle={toggle} active={active} setActive={setActive} />

      <div className={clsx(styles.ellips)}></div>
      <div className={clsx(styles.ellips, styles.second)}></div>
      <div className={clsx(styles.ellips, styles.third)}></div>
    </div>
  );
};
